<script lang="ts">
    import * as yup from 'yup'

    import { gettext as _ } from 'hydria/services/gettext'
    import { notify } from 'hydria/services/notifications'
    import type { INotification } from 'hydria/services/notifications'
    import { simpleFetch } from 'hydria/services/session'
    import { getContext, onDestroy, onMount } from 'svelte'
    import { fade } from 'svelte/transition'
    import type { Writable } from 'svelte/store'
    import { cardHeaderStyle } from 'hydria/context'

    let saving = $state(false)

    let stoken = getContext('securityToken') as Writable<string>

    interface Props {
        keyId: string
        currentName: string
        close: () => void
        saved: () => void
    }

    let { keyId, currentName, close, saved }: Props = $props()

    const schema = yup.object().shape({
        name: yup.string(),
    })

    interface UserEdit {
        name: string
    }
    let orig: UserEdit = {
        name: currentName,
    }
    let edit: UserEdit = $state({ ...orig })

    // @ts-expect-error
    let nameIsValid = $derived(schema.fields.name.isValidSync(edit.name))
    let formIsValid = $derived(schema.isValidSync(edit))

    let dirty = $derived(orig.name != edit.name)

    async function saveData() {
        if (!dirty || saving) return

        saving = true

        const notifyError: INotification = {
            type: 'danger',
            title: $_('Clé d’accès'),
            text: $_('Les données n’ont pas pu être sauvegardées.'),
        }
        let r: any
        try {
            r = await simpleFetch(
                'PUT',
                `/json/security/1/passkey/${keyId}`,
                {
                    name: edit.name,
                },
                { headers: { 'x-security-token': $stoken } },
            )
        } catch (e) {
            console.error('Failed to save user information:', e)
            notify(notifyError)
            focus()
        }
        if (r.data.success) {
            saved()
            close()
        } else {
            notify(notifyError)
            focus()
        }
        saving = false
    }

    let nameElement: HTMLInputElement | undefined = $state()

    function focus() {
        if (nameElement) {
            nameElement.focus()
            nameElement.select()
        }
    }
    onMount(() => {
        focus()
    })

    let addedModalOpen = false
    if (!document.documentElement.classList.contains('modal-open')) {
        document.documentElement.classList.add('modal-open')
        addedModalOpen = true
    }

    onDestroy(() => {
        if (addedModalOpen && document.documentElement.classList.contains('modal-open')) {
            document.documentElement.classList.remove('modal-open')
        }
    })
</script>

<svelte:window
    onkeydown={(e) => {
        if (e.key === 'Escape') {
            if (!saving) {
                close()
            }
        }
    }}
/>

<div class="modal" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <form
                onsubmit={(e) => {
                    e.preventDefault()
                    saveData()
                }}
            >
                <div class="card">
                    <div class={cardHeaderStyle}>{$_('Clé d’accès')}</div>
                    <div class="card-body">
                        <p>{$_('Vous pouvez donner un nom à cette clé.')}</p>

                        <div class="form-group mt-3">
                            <label for="name" class="col-sm-4 col-form-label">{$_('Nom de la clé d’accès')}</label>
                            <input type="text" class="form-control" id="name" bind:value={edit.name} bind:this={nameElement} disabled={saving} class:is-invalid={!nameIsValid} />
                        </div>
                    </div>
                    <div class="card-footer text-end">
                        <button
                            type="button"
                            class="btn btn-outline-secondary"
                            disabled={saving}
                            onclick={() => {
                                close()
                            }}>{$_('Cancel')}</button
                        >
                        <button type="submit" class="btn btn-primary" disabled={saving || !dirty || !formIsValid}>
                            {#if saving}<div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                                {$_('Saving…')}
                            {:else}{$_('Submit changes')}
                            {/if}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
    <div
        class="modal-backdrop"
        onclick={() => {
            if (!saving) close()
        }}
        aria-hidden="true"
    ></div>
</div>
